
import { t } from "@/plugins/i18n";
export default interface BankStatus {
    id: number;
    name: string;
    checked: boolean;
  }
  
  export const bankStatusDefaultProps: BankStatus = {
    id: 0,
    name: t("Osszes"),
    checked: false,
  };